<template>
  <div id="app">
    <!-- <loader></loader> -->
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view/>
  </div>
</template>
<script>
// import Loader from '@/components/Loader'
import { service } from "@/utils/request";
export default {
  name: 'App',
  components: {
    // Loader
  },
  beforeDestroy() {
    this.$store.commit('RESET_ACCOUNT')
    this.$store.commit('RESET_USER')
    this.$store.commit('RESET_LANGUAGE')
    service.request({
      url: 'logout/',
      method: 'GET',
    })
  },
  created() {
    window.addEventListener('beforeunload', this.logout)
  },
  methods: {
    logout() {
      this.$store.commit('RESET_ACCOUNT')
      this.$store.commit('RESET_USER')
      this.$store.commit('RESET_LANGUAGE')
      service.request({
        url: 'logout/',
        method: 'GET',
      })
    }
  }
}
</script>


